<template>
  <Dialog
    width="880px"
    height="unset"
    titleAlign="left"
    :title="$$t('create.song_apply_to_publish')"
    :subTitle="$$t('create.publish_desc')"
    :visible="renderData.visible"
    @close="closeDialog"
    mobileRenderType="drawerDialog"
  >
    <!-- :subTitle="$$t('create.song_apply_to_publish_subtitle')" -->
    <div
      class="height-all go-to-publish flex-column"
      ref="refGoToPublish"
      :class="{ 'go-to-publish--mobile': createRenderType == 'mobile' }"
    >
      <div class="go-to-publish-item-name">
        {{ $$t("create.song_title") }}
        <span
          class="go-to-publish-item-error fn-inline"
          v-if="!!renderDataValid.validataFilename"
        >
          ( {{ renderDataValid.validataFilename }} )
        </span>
      </div>
      <div class="go-to-publish-title flex">
        <input
          :placeholder="$$t('create.edit_feed_song_title')"
          class="flex1 width-0"
          :value="renderData.filename"
          @input="onInput"
          @change="onChange"
          @compositionstart="handleCompositionStart"
          @compositionend="handleCompositionEnd"
        />
        <div class="go-to-publish-title-count">
          {{ renderData.filename?.length ?? 0 }}/ {{ MAX_TITLE_LENGTH }}
        </div>
      </div>
      <div class="go-to-publish-item-name">
        {{ $$t("create.song_cover") }}
        <span
          class="go-to-publish-item-error fn-inline"
          v-if="!!renderDataValid.validataSongCover"
        >
          ( {{ renderDataValid.validataSongCover }} )
        </span>
      </div>
      <div class="go-to-publish-content">
        <UploadClipImage
          :imgUrl="
            renderData.item?.cover ? getObjectStorageFullUrl(renderData.item?.cover) : ''
          "
          :pathKey="renderData.item?.cover"
          :imageExplain="$$t('create.song_publish_image_explain')"
          ref="refUploadClipImage"
          @urlChange="onSongUrlChange"
        ></UploadClipImage>
      </div>
      <!-- <div class="go-to-publish-tags-select flex">
        <div class="go-to-publish-tag-item">
          <div class="go-to-publish-item-name">
            {{ $$t("create.genre") }}
            <span
              class="go-to-publish-item-error fn-inline"
              v-if="!!renderDataValid.validataStyleTag"
            >
              ( {{ renderDataValid.validataStyleTag }} )
            </span>
          </div>
          <Select
            v-model="renderData.styleTag"
            @change="onSelectStyleTag"
            :clearable="false"
            multiple
            :placeholder="$$t('create.genre')"
            :multipleLimit="6"
            :options="getEnOptions(StyleLabelData.list, $$language())"
          ></Select>
        </div>
        <div class="go-to-publish-tag-item">
          <div class="go-to-publish-item-name">
            {{ $$t("create.mood") }}
            <span
              class="go-to-publish-item-error fn-inline"
              v-if="!!renderDataValid.validataMoodTag"
            >
              ( {{ renderDataValid.validataMoodTag }} )
            </span>
          </div>
          <Select
            v-model="renderData.moodTag"
            @change="onSelectMoodTag"
            :clearable="false"
            :placeholder="$$t('create.mood')"
            multiple
            :multipleLimit="6"
            :options="getEnOptions(EmotionalLabelData.list, $$language())"
          ></Select>
        </div>
      </div> -->
      <div class="go-to-publish-done-btn-box">
        <div class="go-to-publish-done-btn">
          <Button
            @click="onDoneClick"
            :renderStyle="{
              '--padding': '0',
              '--width': '100%',
              '--height': '48px',
              '--borderRadius': '50px',
              '--fontColor': '#000',
              '--fontSize': '16px',
              '--fontWeight': 'normal',
              '--border': 'none',
              '--background':
                'linear-gradient(120deg, rgb(79, 222, 255, 1) -1%, rgb(230, 117, 255, 1) 100%)', //#94ADFF
              '--backgroundHover':
                'linear-gradient(120deg, rgb(79, 222, 255, 0.75) -1%, rgb(230, 117, 255, 0.75) 100%)',
              '--fontColorHover': '#000',
            }"
          >
            {{ $$t("create.publish") }}
          </Button>
        </div>
      </div>
      <!-- <div class="go-to-publish-items" v-if="globalConfig.appname != chinaAppName">
        <div
          class="singer-radio-box fn-inline pointer"
          :class="{
            'singer-radio-box-selected': renderData.singerRadioSlectedState,
          }"
          @click="toggleSingerRadio"
        >
          <i class="block"></i>
        </div>
        Allow other users to purchase license for this song.
        <span class="pointer" @click="goToTerms">Learn more</span>
      </div>
      <div class="go-to-publish-items" v-if="globalConfig.appname == chinaAppName">
        <div
          class="singer-radio-box fn-inline pointer"
          :class="{
            'singer-radio-box-selected': renderData.singerRadioSlectedState,
          }"
          @click="toggleSingerRadio"
        >
          <i class="block"></i>
        </div>
        允许其他用户购买该歌曲的许可。
        <span class="pointer" @click="goToTerms">了解更多</span>
      </div> -->

      <!-- <div class="go-to-publish-desc">
        {{ $$t("create.publish_desc") }}
      </div> -->
    </div>
  </Dialog>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  readonly,
  reactive,
  watch,
  defineExpose,
  onMounted,
  onUpdated,
  onUnmounted,
  getCurrentInstance,
} from "vue"
import globalConfig, { chinaAppName } from "@/config/config.js"
import { useRouter, useRoute } from "vue-router"
import message from "@/components/functionCallComponent/message.jsx"
import feedListApi from "@/api/api/feedListApi.js"

import Dialog from "@/components/basic/dialog/Dialog.vue"
import Button from "@/components/basic/button/Button.vue"
import UploadClipImage from "@/components/basic/uploadClipImage/uploadClipImage.vue"
import {
  StyleLabelData,
  EmotionalLabelData,
  getEnOptions,
  getSelectValue,
} from "@/config/const.js"

import objectStorage, {
  getObjectStorageFullUrl,
} from "@/lib/objectStorage/objectStorage.js"

import { storeToRefs } from "pinia"
import useCreateLayoutStore from "@/store/create/createLayoutStore.js"

const createLayoutStore = useCreateLayoutStore()
const { createRenderType } = storeToRefs(createLayoutStore)

const globalProperties = (
  getCurrentInstance() || window?.$getVueCurrentInstance?.()
).appContext?.config?.globalProperties
const { $$language, $$t, $$tm, $$tValue } = getCurrentInstance().appContext?.config.globalProperties.$i18n ?? {}

const MAX_TITLE_LENGTH = 50

const Router = (getCurrentInstance() || window?.$getVueCurrentInstance?.())
  .appContext?.config?.globalProperties?.$router
const props = defineProps({
  item: {
    type: Object,
    default: null,
  },
  pitem: {
    type: Object,
    default: null,
  },
  visible: {
    type: Boolean,
    default: true,
  },
})
const emits = defineEmits(["update:visible", "done", "complete"])

const refUploadClipImage = ref(null)
const refGoToPublish = ref(null)

const stateData = {
  filenameRule: [
    (v) => !!v || $$t("create.this_field_is_required"),
    (v) =>
      (v.length >= 1 && v.length <= MAX_TITLE_LENGTH) ||
      $$tValue("create.song_name_max_characters", { num: MAX_TITLE_LENGTH }),
    // (v) =>
    //   /^[\u4e00-\u9fa50-9A-Za-z]+$/.test(v) || "仅支持输入“汉字、字母、数字”",
  ],
  moodOptions: getEnOptions(EmotionalLabelData.list,  $$language()),
  styleOptions: getEnOptions(StyleLabelData.list, $$language()),
}

const childInfo = ref(null)

const renderData = reactive({
  item: props.item,
  pitem: props.pitem,
  imageData: {},
  uploadCallbackData: null,
  singerRadioSlectedState: false,
  visible: props.visible,
  filename: props.item?.title,
  moodTag: (
    getSelectValue(props.item.moods, EmotionalLabelData.map, $$language()) ?? []
  ).slice(0, 6),
  styleTag: (getSelectValue(props.item.genres, StyleLabelData.map, $$language()) ?? []).slice(
    0,
    6
  ),
})
const renderDataValid = reactive({
  validataFilename: "",
  validataMoodTag: "",
  validataStyleTag: "",
  validataSongCover: "",
})
const handleCompositionStart = () => {
  renderData.inputing = true
}

const handleCompositionEnd = (e) => {
  renderData.inputing = false
  onInput(e)
}
const onInput = (e) => {
  if (!renderData.inputing) {
    if (e.target.value.length > MAX_TITLE_LENGTH) {
      e.target.value = e.target.value.slice(0, MAX_TITLE_LENGTH)
    }
    renderData.filename = e.target.value
  }
}
const onChange = (e) => {
  validMap.validataFilename(renderData.filename)
}

const validMap = {
  validataFilename: (filename) => {
    let index = stateData.filenameRule.findIndex((v) => v(filename) != true)
    if (index >= 0) {
      renderDataValid.validataFilename = stateData.filenameRule[index](filename)
      return false
    }
    renderDataValid.validataFilename = ""
    return true
  },
  validataMoodTag: (moodTag) => {
    if (!moodTag?.length) {
      renderDataValid.validataMoodTag = $$t("create.this_field_is_required")
      return false
    } else {
      renderDataValid.validataMoodTag = ""
      return true
    }
  },
  validataStyleTag: (styleTag) => {
    if (!styleTag?.length) {
      renderDataValid.validataStyleTag = $$t("create.this_field_is_required")
      return false
    } else {
      renderDataValid.validataStyleTag = ""
      return true
    }
  },
}
const onSongUrlChange = (hasUrl) => {
  if (hasUrl) {
    renderDataValid.validataSongCover = ""
  } else {
    renderDataValid.validataSongCover = $$t("create.this_field_is_required")
  }
}
const onSelectMoodTag = (item) => {
  renderData.moodTag = item
  validMap.validataMoodTag(item)
}
const onSelectStyleTag = (item) => {
  renderData.styleTag = item
  validMap.validataStyleTag(item)
}

const onClose = () => {
  renderData.visible = false
  renderData.filename = ""
  renderData.moodTag = null
  renderData.styleTag = null
  emits("update:visible", false)
  emits("cancel")
}

const toggleSingerRadio = (e) => {
  renderData.singerRadioSlectedState = !renderData.singerRadioSlectedState
}

const doUploadImage = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const objectStorageRes = await objectStorage.uploadFileToObjectStorage(
        renderData.imageData.file,
        (obj) => {
          renderData.uploadCallbackData = obj
        }
      )
      resolve(objectStorageRes)
    } catch (e) {
      reject(e)
    }
  })
}

const onDoneClick = async () => {
  let validataFilename = await validMap.validataFilename(renderData.filename)
  // let validataMoodTag = await validMap.validataMoodTag(renderData.moodTag);
  // let validataStyleTag = await validMap.validataStyleTag(renderData.styleTag);
  globalProperties?.logClickEvent("create_publish", {
    content_id: renderData.item?.song_id,
  })
  try {
    renderData.imageData = await refUploadClipImage.value?.getClipImageData()
    if (!renderData.imageData?.file) {
      renderDataValid.validataSongCover = $$t("create.this_field_is_required")
      nextTick().then(() => {
        refGoToPublish.value
          ?.querySelector(".go-to-publish-item-error")
          ?.scrollIntoView()
      })
      return
    } else {
      renderDataValid.validataSongCover = ""
    }
  } catch (e) {
    // message.error({
    //   content: $$t("create.please_upload_song_covers"),
    //   position: "top",
    // });
    renderDataValid.validataSongCover = $$t("create.this_field_is_required")
    nextTick().then(() => {
      refGoToPublish.value
        ?.querySelector(".go-to-publish-item-error")
        ?.scrollIntoView()
    })
    return
  }
  // if (validataMoodTag && validataStyleTag && validataFilename) {
  if (validataFilename) {
    emits(
      "complete",
      renderData.pitem,
      renderData.item,
      renderData.imageData,
      {
        song_id: renderData.item?.song_id,
        title: renderData.filename,
        // moods: renderData.moodTag?.map((v) => v.value),
        // genres: renderData.styleTag?.map((v) => v.value),
        type: 1,
      },
      () => {
        renderData.filename = ""
        renderData.moodTag = null
        renderData.styleTag = null
        emits("update:visible", false)
      }
    )
  } else {
    nextTick().then(() => {
      refGoToPublish.value
        ?.querySelector(".go-to-publish-item-error")
        ?.scrollIntoView()
    })
  }
}

const closeDialog = () => {
  renderData.visible = false
}

const goToTerms = () => {
  window.open(window.location.origin + "/terms", "_blank")
}

watch(
  () => props.visible,
  (val) => {
    renderData.visible = props.visible
    renderData.filename = props.item?.title
  }
)

watch(
  () => renderData.visible,
  (val) => {
    emits("update:visible", val)
  }
)

onMounted(() => {})
</script>
<style lang="scss">
.go-to-publish {
  padding: 13px 40px 40px 40px;

  .go-to-publish-item-name {
    margin-top: 20px;
    font-family: HarmonyOS Sans SC;
    font-size: 14px;
    font-weight: normal;
    line-height: 20px;
    height: 20px;
    color: #ffffff;
    margin-bottom: 8px;
    .go-to-publish-item-error {
      color: #ff5f74;
    }
    &:first-child {
      margin-top: 0;
    }
  }

  .go-to-publish-title {
    height: 48px;
    border-radius: 8px;
    padding: 0 16px;
    background: rgba(255, 255, 255, 0.1);
    align-items: center;
    input {
      height: 100%;
      width: 100%;
      font-family: HarmonyOS Sans SC;
      font-size: 16px;
      font-weight: normal;
      line-height: 22px;
      color: #ffffff;
      border: none;
      outline: none;
      background: transparent;
      color: #ffffff;
      &::placeholder {
        color: rgba(255, 255, 255, 0.5) !important;
      }
    }
    .go-to-publish-title-count {
      font-size: 14px;
      font-weight: normal;
      line-height: 20px;
      height: 20px;
      color: rgba(255, 255, 255, 0.5);
    }
  }

  .go-to-publish-content {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 8px;
    margin: 0 0 0 0;
    min-height: 100px;
  }

  .go-to-publish-done-btn-box {
    .go-to-publish-done-btn {
      margin: 20px auto 0 auto;
      width: 100%;
    }
  }
  .singer-radio-box {
    width: 24px;
    height: 24px;
    padding: 2px;
    i {
      width: 20px;
      height: 20px;
      border-radius: 50%;
      box-sizing: border-box;
      border: 2px solid rgba(255, 255, 255, 0.3);
      margin-right: 6px;
    }
    &.singer-radio-box-selected {
      background: url("@/assets/img/radio-selected-ico.png");
      background-size: 100% 100%;
      i {
        display: none;
      }
    }
  }
  .go-to-publish-items {
    margin: 22px auto 0 auto;
    font-size: 14px;
    font-weight: normal;
    line-height: 20px;
    color: rgba(255, 255, 255, 0.5);
    span {
      color: #ffffff;
      &:hover {
        color: #94adff;
      }
    }
  }
  .go-to-publish-desc {
    margin: 20px 0 0 0;
    font-family: HarmonyOS Sans SC;
    font-size: 14px;
    font-weight: normal;
    line-height: 20px;
    color: rgba(255, 255, 255, 0.75);
  }
  .go-to-publish-tags-select {
    margin: 20px 0 0 0;
    .go-to-publish-tag-item {
      width: 0;
      flex: 1;
      &:last-child {
        margin: 0 0 0 12px;
      }
    }
    .el-select__wrapper {
      border-radius: 8px;
      padding: 7px 12px;
      height: 48px;
    }
  }
  &.go-to-publish--mobile {
    padding: 15px 16px 16px 16px;
    .go-to-publish-tags-select {
      display: block;
      .go-to-publish-tag-item {
        margin: 0 0 0 0px;
        width: 100%;
        &:last-child {
          margin: 15px 0 0 0px;
        }
      }
    }
    .go-to-publish-done-btn-box {
      .go-to-publish-done-btn {
        margin: 16px auto 16px auto;
      }
    }
    .go-to-publish-desc {
      margin: 0 0 0 0;
    }
  }
}
</style>
